import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";

import Header from "./components/Header";
import NotFaund from "./pages/NotFound/index";

import Info from "./pages/Info";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import HeaderMobile from "./components/Header/HeaderMobile";


function RoutesApi(){
  return(
    <BrowserRouter>
    <Header />
    <HeaderMobile/>
    <Routes>
      <Route path="/" element={<Home/>} ></Route>
      <Route path="/info" element={<Info/>}></Route>
      <Route path="/contact"  element={<Contact/>}/>
      <Route path="*" element={<NotFaund/>}></Route>

    </Routes>
    <Footer/>
    </BrowserRouter>
  )
}
export default RoutesApi;